import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData, postData } from "src/utils/axios/serverHelper";
import {
  PDA1122_R01InputRequest,
  PDA1122_R01InputItem,
  PDA1122_R01OrderDto,
  PDA1122_R01ScanResult,
  PDA1122_R01SearchParams,
} from "src/containers/PDA/PDA1122_R01/PDA1122_R01Dto";

const baseUrl = `${config.apiUrl}/PDA1122_R01`;

export const searchOrders = (params?: PDA1122_R01SearchParams) =>
  getData<ResponseDto<PDA1122_R01OrderDto[]>>(`${baseUrl}/search`, { params });

export const refetchOrders = (params?: PDA1122_R01SearchParams) =>
  getData<ResponseDto<PDA1122_R01OrderDto[]>>(`${baseUrl}/refetch`, { params });

export const validateLot = (productOrderNo: string, lotNo: string) =>
  getData<ResponseDto<PDA1122_R01ScanResult>>(
    `${baseUrl}/validate-lot/${encodeURIComponent(productOrderNo)}/${encodeURIComponent(lotNo)}`
  );

export const getInputList = (productOrderNo: string) =>
  getData<ResponseDto<PDA1122_R01InputItem[]>>(
    `${baseUrl}/inputs/${encodeURIComponent(productOrderNo)}`
  );

export const createInput = (request: PDA1122_R01InputRequest) =>
  postData<PDA1122_R01InputRequest, ResponseDto<string>>(baseUrl, request);
